
export class Line {
    id: number | undefined;
    name: string | undefined;
    siteId: number | undefined;
}

export class Site {
    id: number | undefined;
    name: string | undefined;
}